import { Button, Card, Col, Flex, Typography } from 'antd'
import React from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom';
import Success from "../images/success.gif";
const PaymentSuccessScreen = () => {
    const {Text, Title} = Typography;
    const searchQuery = useSearchParams()[0];
    const referenceid = searchQuery.get("reference");
    const navigate = useNavigate();
    return (

        <Flex justify='center' style={{height: "100vh"}}>
            <Col md={10}>
                <Card style={{textAlign: "center"}} title={"🎉 Payment Successful! 🎉"} actions={[<Button onClick={e => navigate('/Dashboard')} type='primary'>Go Back to Dashboard</Button>]}>
                
                <Title level={5}>
                    Thank you for your payment! Your transaction has been processed successfully, and your Lincfolio subscription is now active.
                </Title>
                <img src={Success}/>
                <Title level={5}>
                    Your Payment reference Id: {referenceid}
                </Title>

                <Title level={5}>
                    Welcome to an enhanced trading journey with access to all premium features, tools, and insights that make Lincfolio "your trading hero!"
                </Title>

                <Title level={5}>
                    If you have any questions or need assistance, please reach out to our support team.
                </Title>

                <Title level={5}>
                    Happy trading, and let’s grow together!
                </Title>
                </Card>
            </Col>
        </Flex>
    )
}

export default PaymentSuccessScreen